import {
  CContainer,
  CHeader,
  CHeaderBrand,
  CHeaderNav,
  CDropdown,
  CDropdownToggle,
  CDropdownMenu,
  CDropdownItem,
  CDropdownDivider,
  CHeaderToggler,
  CButton,
  CInputGroup,
  CFormInput
} from "@coreui/react";
import CIcon from '@coreui/icons-react';
import { 
  cilMenu, 
  cilSearch,
  cilSettings,
  cilUser,
  cilAccountLogout
} from '@coreui/icons';
import { signOut } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import { auth } from '../config/firebase';
import { useAuthState } from 'react-firebase-hooks/auth';

const Header = ({ sidebarShow, setSidebarShow }) => {
  const navigate = useNavigate();
  const [user] = useAuthState(auth);

  const handleLogout = async () => {
    try {
      await signOut(auth);
      localStorage.removeItem('firebaseIdToken');
      localStorage.removeItem('firebaseUser');
      navigate('/');
    } catch (error) {
      console.error('Error signing out:', error);
    }
  };
  return (
    <CHeader position="sticky" className="bg-white border-bottom header-shadow mb-3">
      <CContainer fluid>
        <CHeaderToggler
          className="ps-1"
          onClick={() => setSidebarShow(!sidebarShow)}
        >
          <CIcon icon={cilMenu} size="lg" />
        </CHeaderToggler>
        
        <CHeaderBrand className="d-md-none mx-auto">
          <strong>Alexa Skills</strong>
        </CHeaderBrand>

        <CHeaderNav className="d-none d-md-flex me-auto">
          {/* We removed the header nav links as they are in the sidebar now */}
        </CHeaderNav>

        <CInputGroup className="header-search mx-right d-none d-md-flex" style={{ maxWidth: '400px' }}>
          <CFormInput
            placeholder="Search"
            size="sm"
            className="border-end-0"
          />
          <CButton type="button" color="primary" variant="outline" className="border-start-0">
            <CIcon icon={cilSearch} size="sm" />
          </CButton>
        </CInputGroup>

        <CHeaderNav className="ms-3">          
          <div className="header-nav-item">
            <CDropdown alignment="end">
              <CDropdownToggle placement="bottom-end" className="py-0" color="light">
                <div className="avatar avatar-md rounded-circle bg-light p-1">
                  <img 
                    src="https://cdn-icons-png.flaticon.com/512/147/147142.png" 
                    alt="User" 
                    className="rounded-circle" 
                    width="36" 
                    height="36" 
                  />
                </div>
              </CDropdownToggle>
              <CDropdownMenu className="pt-0 mt-2">
                <CDropdownItem disabled>
                  <CIcon icon={cilUser} className="me-2" />
                  {user?.email || 'User'}
                </CDropdownItem>
                <CDropdownDivider />
                <CDropdownItem onClick={handleLogout} style={{ cursor: 'pointer' }}>
                  <CIcon icon={cilAccountLogout} className="me-2" />
                  Log Out
                </CDropdownItem>
              </CDropdownMenu>
            </CDropdown>
          </div>
        </CHeaderNav>
      </CContainer>
    </CHeader>
  );
};

export default Header;
